import { Brain, CheckCircle2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * "What you'll get" reassurance card — small muted block with three
 * checkmark bullets, placed in the right column of the upload page to
 * balance the height of the dropzone on the left and tell the user
 * what the analysis produces.
 */
export function ValuePropCard() {
  const { t } = useTranslation();

  const bullets = [
    t('ORGCONTRACTCHECKER_PREVIEW_RISK', {
      defaultValue: 'Risk flagging on high-stakes clauses',
    }),
    t('ORGCONTRACTCHECKER_PREVIEW_OPPORTUNITIES', {
      defaultValue: 'Negotiation opportunities tailored to your role',
    }),
    t('ORGCONTRACTCHECKER_PREVIEW_CLAUSES', {
      defaultValue: 'Clause-by-clause recommendations',
    }),
  ];

  return (
    <div className="rounded-xl border border-border bg-muted/40 p-4 sm:p-5">
      <div className="flex items-center gap-2 mb-3 text-selise-blue">
        <Brain className="w-4 h-4 shrink-0" />
        <span className="text-[11px] font-semibold uppercase tracking-wider">
          {t('ORGCONTRACTCHECKER_PREVIEW_TITLE', { defaultValue: "What you'll get" })}
        </span>
      </div>
      <ul className="space-y-2 text-sm text-globe-grey">
        {bullets.map((bullet) => (
          <li key={bullet} className="flex items-start gap-2">
            <CheckCircle2 className="w-4 h-4 text-poly-green shrink-0 mt-0.5" />
            <span>{bullet}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ValuePropCard;
